import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../../gd-components/gd-popover/@const"
import FieldIconWithColor_PopoverContent from "./popover-content"

const debug = false
// const debug = "FieldIconWithColor_Popover"

const popoverPosition = new PopoverPosition({
    attachment      : "top center",
    targetAttachment: "bottom center",
    attachmentType  : PopoverAttachmentType.FULL,
})

export default function FieldIconWithColor_Popover(props:any) {

    const {icon, color} = props.model[props.field.fieldId]

    debug && console.log(debug, 'render', icon, color, props.field.options)

    const onValueChange = (value: {
        icon    : string,
        color   : number
    }) => {
        // props.parent.hidePopover()
        props.parent.onValueChange(value)
    }

    return (
        <Popover position         = {popoverPosition}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}>
            <FieldIconWithColor_PopoverContent options          = {props.field.options}
                                               icon             = {icon}
                                               color            = {color}
                                               onValueChange    = {onValueChange}/>
        </Popover>
    )
}